import { useQuery } from 'react-query';

import { DutyCalculationCodes } from '../../types';

import { categoriesToOptionsConverter } from '../../../DutyHourTypes/components/utils/categoriesToOptionsConverter';

import { getDutyCalculationCodes } from 'RestAPIs/dtrRules';

import { MultiSelectOption } from 'components/shared/MultipleSelectCheckmarks';

export const useGetDccOptions = () =>
  useQuery<MultiSelectOption[]>({
    queryKey: ['dutyCalculationCodes', 'options'],
    queryFn: async () =>
      await getDutyCalculationCodes().then(
        categoriesToOptionsConverter<DutyCalculationCodes>({
          getLabel: (option) => option.description,
          getValue: (option) => option.dccId,
          sortBy: 'label'
        })
      ),
    staleTime: Infinity
  });
